import TextArea from 'antd/es/input/TextArea';
import Modal from 'antd/es/modal/Modal';
import { useEffect, useState } from 'react';

import { CANCEL, SAVE } from '@app/constants';

interface OrganizationCommentModalProps {
  open: boolean;
  organizationComment: string;
  isLoading: boolean;
  handleCloseModal: () => void;
  handleSaveComment: (value: string) => Promise<boolean>;
}

export const OrganizationCommentModal = ({
  open,
  handleCloseModal,
  organizationComment,
  handleSaveComment,
  isLoading,
}: OrganizationCommentModalProps) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) {
      setValue(organizationComment || '');
    }
  }, [organizationComment, open]);

  return (
    <Modal
      open={open}
      title="Комментарий к организации"
      okText={SAVE}
      cancelText={CANCEL}
      onCancel={handleCloseModal}
      onOk={() => handleSaveComment(value)}
      okButtonProps={{ loading: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      Комментарий к организации
      <TextArea
        rows={4}
        maxLength={5000}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </Modal>
  );
};
